// No fields require validation -- the modal has nothing left to gate Save on now that the
// confirmation checkbox was replaced with a purely informational notice.
export function kinderConnectCaptureSettingsFormValuesValidator(_formValues) {
    return {};
}
